module.exports = __webpack_public_path__ + "static/media/mainicon2.f47bc495.png";